module.exports = __webpack_public_path__ + "img/149.a414d4ad.jpg";